import ReactDOM from 'react-dom/client'
import { BrowserRouter as Router } from 'react-router-dom'
import { Provider } from 'react-redux'
import { StrictMode } from 'react'
import { store } from 'store/store'
import App from './App'

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href') ?? undefined
const root = ReactDOM.createRoot(document.getElementById('root') as Element)

root.render(
  <StrictMode>
    <Provider store={store}>
      <Router basename={baseUrl}>
        <App />
      </Router>
    </Provider>
  </StrictMode>,
)
